// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__yd8K8","burgerOpen":"burgerOpen__rG7JA","burgerClose":"burgerClose__wnP1S","light":"light__ZfJec","dark":"dark__8knRu"};